export { TermsAndConditionsScreen } from "./TermsAndConditionsScreen";
